module.exports = __webpack_public_path__ + "img/seaPalace-4.599702cb.jpg";